function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M19.5 9.375L14.9375 8.71875L12.875 4.5625C12.5312 3.84375 11.4688 3.8125 11.0938 4.5625L9.0625 8.71875L4.46875 9.375C3.65625 9.5 3.34375 10.5 3.9375 11.0938L7.21875 14.3125L6.4375 18.8438C6.3125 19.6562 7.1875 20.2812 7.90625 19.9062L12 17.75L16.0625 19.9062C16.7812 20.2812 17.6562 19.6562 17.5312 18.8438L16.75 14.3125L20.0312 11.0938C20.625 10.5 20.3125 9.5 19.5 9.375ZM15.125 13.7812L15.875 18.0938L12 16.0625L8.09375 18.0938L8.84375 13.7812L5.6875 10.7188L10.0312 10.0938L12 6.15625L13.9375 10.0938L18.2812 10.7188L15.125 13.7812Z",
  fill: "#191B1C"
}));

var SvgIcnSpecialities = function SvgIcnSpecialities(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnSpecialities, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-specialities.edace39c.svg";
export { ForwardRef as ReactComponent };